import { actions as tag } from '../reducers/tag';
import { actions as teaser } from '../reducers/teaser';
import { actions as filter } from '../reducers/filter';
import { actions as system } from '../reducers/system';
import { actions as person } from '../reducers/person';

export const actions = {
	tag,
	teaser,
	filter,
	system,
	person
};


// WEBPACK FOOTER //
// ./src/actions/actionCreators.js